import { createFileRoute, Link } from "@tanstack/react-router";
import { setCookie } from "@tanstack/react-start/server";
import { GalleryVerticalEnd } from "lucide-react";
import * as oidc from "openid-client";
import { Button } from "@/components/ui/button";
import {
	getJumpcloudOidcConfig,
	newJumpcloudOidcPkce,
	redirectUri,
} from "@/lib/jumpcloud";
import { sign } from "@/lib/session-utils";

export const Route = createFileRoute("/auth/login")({
	component: Page,
	server: {
		handlers: {
			POST: async () => {
				const config = await getJumpcloudOidcConfig();
				const { codeVerifier, codeChallenge, state, nonce } =
					await newJumpcloudOidcPkce();

				const authorizeUrl = oidc.buildAuthorizationUrl(config, {
					redirect_uri: redirectUri,
					response_type: "code",
					scope: "openid profile email offline_access",
					code_challenge: codeChallenge,
					code_challenge_method: "S256",
					state,
					nonce,
				});

				const tmp = sign(
					JSON.stringify({ state, nonce, codeVerifier, t: Date.now() }),
				);

				setCookie("jc_tmp", tmp, {
					httpOnly: true,
					secure: true,
					sameSite: "lax",
					maxAge: 5 * 60,
					path: "/",
				});

				return new Response(null, {
					status: 302,
					headers: { Location: authorizeUrl.toString() },
				});
			},
		},
	},
});

function Page() {
	return (
		<div className="flex flex-col items-center justify-center flex-1 min-h-screen">
			<form method="post" className="flex flex-col gap-6">
				<div className="flex flex-col items-center justify-center gap-2 text-center">
					<Link to="/" className="flex flex-col items-center gap-2 font-medium">
						<div className="flex size-8 items-center justify-center rounded-md">
							<GalleryVerticalEnd className="size-6" />
						</div>
						<span className="sr-only">Azerion Podcast Backoffice</span>
					</Link>
					<h1 className="text-xl font-bold">Azerion Podcast Backoffice</h1>
				</div>

				<Button variant="outline" type="submit" className="w-full">
					Continue with
					<img
						src="/jumpcloud-logo.svg"
						alt="JumpCloud Logo"
						className="h-4 mr-2"
					/>
				</Button>
			</form>
		</div>
	);
}
